// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Switch } from '@/ui';
import {
  StyledTitle,
  StyledPostsWrap,
  StyledWrapper,
  StyledText,
  StyledHideBlock,
} from './PropertyDocumentsListStyles';
import PropertyDocumentSourceItem from '../PropertyDocumentSourceItem/PropertyDocumentSourceItem';

// Models
import { DocumentSourceEnum, IPackageDocumentDTOes } from '@/models/documents.model';

// Modules
import { DesktopOnly } from '@/modules/Adaptive';

type TPropertyDocumentsList = {
  propertyDocuments: IPackageDocumentDTOes | null;
  onUpdateDocumentStatus: (id: string, is_checked: boolean) => void;
  uploadedHidden?: boolean;
  setIsUploadedHidden: (v: boolean) => void;
  disabled?: boolean;
};

const PropertyDocumentsList = ({
  propertyDocuments,
  onUpdateDocumentStatus,
  uploadedHidden,
  setIsUploadedHidden,
  disabled = false,
}: TPropertyDocumentsList) => {
  const { t } = useTranslation(['documents']);
  const propertyEntries = Object.entries(propertyDocuments ?? {}).filter(([, documents]) => documents?.length);
  return (
    <StyledWrapper>
      <DesktopOnly>
        <>
          <StyledTitle>{t('documents_list_of_documents')}</StyledTitle>
          <StyledText>{t('documents_list_of_documents_description')}</StyledText>
        </>
      </DesktopOnly>
      <StyledHideBlock>
        <Switch value={uploadedHidden} onChange={(v) => setIsUploadedHidden(v)} />
        {t('documents_list_of_documents_hide_uploaded')}
      </StyledHideBlock>
      <StyledPostsWrap>
        {propertyEntries?.map(([source, documents], idx) => (
          <PropertyDocumentSourceItem
            documents={documents}
            key={source}
            source={source as DocumentSourceEnum}
            onUpdateDocumentStatus={onUpdateDocumentStatus}
            uploadedHidden={uploadedHidden}
            isLastOne={idx === propertyEntries?.length - 1}
            disabled={disabled}
          />
        ))}
      </StyledPostsWrap>
    </StyledWrapper>
  );
};

export default PropertyDocumentsList;
